import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { CREATE_JIRA_TICKET_LABELS } from './createJiraTicket.constants';

function NRCreateVulnerabilityJiraTicketActions({ canCreate, isCreating, onCancel, onCreate }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: theme.spacing(1.5)
      }}
    >
      <Button variant="outlined" color="secondary" onClick={onCancel} disabled={isCreating}>
        {CREATE_JIRA_TICKET_LABELS.CANCEL}
      </Button>
      <Button variant="contained" color="secondary" disabled={!canCreate} onClick={onCreate}>
        {CREATE_JIRA_TICKET_LABELS.CREATE}
      </Button>
    </Box>
  );
}

/**
 * Mount once in FiltersContext footer. Parent updates canCreate/isCreating via bridgeRef
 * and keeps onCancel/onCreate as latest function refs — avoids rewriting context on each keystroke.
 */
export function NRCreateVulnerabilityJiraTicketActionsController({ bridgeRef }) {
  const [ui, setUi] = useState(() => ({
    canCreate: bridgeRef.current.canCreate,
    isCreating: bridgeRef.current.isCreating
  }));

  useEffect(() => {
    const bridge = bridgeRef.current;
    const sync = () => {
      setUi({
        canCreate: bridge.canCreate,
        isCreating: bridge.isCreating
      });
    };
    bridge.subscribe = sync;
    sync();
    return () => {
      if (bridge.subscribe === sync) {
        bridge.subscribe = null;
      }
    };
  }, [bridgeRef]);

  return (
    <NRCreateVulnerabilityJiraTicketActions
      canCreate={ui.canCreate}
      isCreating={ui.isCreating}
      onCancel={() => bridgeRef.current.onCancel()}
      onCreate={() => bridgeRef.current.onCreate()}
    />
  );
}

export default NRCreateVulnerabilityJiraTicketActions;
